//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    deferredPrompt: null,
  }),
  methods: {
    async dismissMsg() {
      this.deferredPrompt = null;
    },
    async installApp() {
      this.deferredPrompt.prompt();
    },
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
  },
};
